import * as types from "../actions/types";
/******************* 
@purpose : Intital mytrips reducer data
@Author : INIC
******************/
const initialState = {
  pastTripData: {
    data: [],
    links: "",
  },
  currentTripData: {
    data: [],
    links: "",
  },
  futureTripData: {
    data: [],
    links: "",
  },
};

/******************* 
@purpose : mytrips Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function mytrips(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /

    case types.CLEAR_PAST_TRIPS:
      return Object.assign({}, ini_data, {
        pastTripData: {
          data: [],
          links: "",
        },
      });

    case types.SET_PAST_TRIPS:
      if (ini_data.pastTripData.data.length > 0) {
        return Object.assign({}, ini_data, {
          pastTripData: {
            data: ini_data.pastTripData.data.concat(action.data.data),
            links: action.data.links,
          },
        });
      } else {
        return Object.assign({}, ini_data, {
          pastTripData: {
            data: action.data.data,
            links: action.data.links,
          },
        });
      }

    case types.CLEAR_CURRENT_TRIPS:
      return Object.assign({}, ini_data, {
        currentTripData: {
          data: [],
          links: "",
        },
      });

    case types.SET_CURRENT_TRIPS:
      if (ini_data.currentTripData.data.length > 0) {
        return Object.assign({}, ini_data, {
          currentTripData: {
            data: ini_data.currentTripData.data.concat(action.data.data),
            links: action.data.links,
          },
        });
      } else {
        return Object.assign({}, ini_data, {
          currentTripData: {
            data: action.data.data,
            links: action.data.links,
          },
        });
      }

    case types.CLEAR_FUTURE_TRIPS:
      return Object.assign({}, ini_data, {
        futureTripData: {
          data: [],
          links: "",
        },
      });

    case types.SET_FUTURE_TRIPS:
      if (ini_data.futureTripData.data.length > 0) {
        return Object.assign({}, ini_data, {
          futureTripData: {
            data: ini_data.futureTripData.data.concat(action.data.data),
            links: action.data.links,
          },
        });
      } else {
        return Object.assign({}, ini_data, {
          futureTripData: {
            data: action.data.data,
            links: action.data.links,
          },
        });
      }

    default:
      return ini_data;
  }
}
